import React, { CSSProperties } from 'react';
import { Props } from 'reactjs-popup';
import { getRem } from '../../utils';

import {
  contentStyle,
  overlayStyle,
  Paragraph,
  ParagraphLink,
  TooltipAnimation,
  PopupEmotion
} from './styles';

export type PositionType =
  | 'top center'
  | 'top right'
  | 'bottom center'
  | 'bottom left'
  | 'bottom right'
  | 'left center'
  | 'right center';

type WidthType = number | 'auto';

export interface TooltipProps {
  width?: WidthType;
  position?: PositionType;
  isArrow?: boolean;
  padding?: string;
}

export function Tooltip(props: Props & TooltipProps) {
  const {
    position = 'top center',
    isArrow = true,
    padding = '1.5rem 2.5rem',
    width,
    ...other
  } = props;

  return (
    <PopupEmotion
      arrow={false}
      isArrow={isArrow}
      position={position}
      offsetX={getOffsetX(position)}
      offsetY={getOffsetY(position)}
      contentStyle={
        { ...contentStyle, ...TooltipAnimation, width: getWidth(width), padding } as CSSProperties
      }
      overlayStyle={overlayStyle}
      {...other}
    >
      {props.children}
    </PopupEmotion>
  );
}

Tooltip.Paragraph = Paragraph;
Tooltip.ParagraphLink = ParagraphLink;

function getWidth(width?: WidthType) {
  switch (typeof width) {
    case 'number':
      return getRem(width);

    case 'string':
      return 'max-content';

    default:
      return '20rem';
  }
}

function getOffsetX(position: PositionType) {
  switch (position.split(' ')[0]) {
    case 'left':
    case 'right':
      return 18;

    default:
      return 0;
  }
}

function getOffsetY(position: PositionType) {
  switch (position.split(' ')[0]) {
    case 'top':
    case 'bottom':
      return 18;

    default:
      return 0;
  }
}
